import { motion } from "framer-motion";
import { Search, ArrowLeft } from "lucide-react";

export default function BlogHero({ onSearch, showBack = false }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    const value = new FormData(e.currentTarget).get("q");
    onSearch?.(String(value || ""));
  };

  return (
    <section className="relative py-16 bg-emerald-50 sm:py-32">
      {/* soft pattern */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(16,185,129,0.12)_1px,transparent_1px)] [background-size:16px_16px]" />
      <div className="absolute -top-24 -left-24 w-64 h-64 rounded-full blur-3xl bg-emerald-300/30" />
      <div className="absolute -right-24 -bottom-24 w-64 h-64 rounded-full blur-3xl bg-emerald-200/30" />

      <div className="relative px-6 mx-auto max-w-6xl">
        {showBack && (
          <button
            type="button"
            onClick={() => window.history.back()}
            className="inline-flex gap-2 items-center text-sm text-emerald-700 hover:underline"
          >
            <ArrowLeft size={16} /> Back
          </button>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="text-3xl font-extrabold text-gray-900 sm:text-4xl"
        >
          TripSecure Blogs
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.05, duration: 0.4 }}
          className="mt-2 max-w-2xl text-sm text-gray-700"
        >
          Insights, education, and updates about safe, stress‑free travel and embedded insurance.
        </motion.p>

        <motion.form
          onSubmit={handleSubmit}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.4 }}
          className="flex gap-2 items-center p-2 mt-6 w-full max-w-xl bg-white rounded-xl ring-1 shadow ring-emerald-600/20"
        >
          <div className="flex gap-2 items-center px-2 w-full h-11">
            <Search size={16} className="text-emerald-600" />
            <input
              name="q"
              placeholder="Search articles, topics, or keywords"
              className="flex-1 h-full text-sm bg-transparent focus:outline-none placeholder:text-gray-400"
            />
          </div>
          <button
            type="submit"
            className="px-5 h-11 text-sm font-semibold text-white bg-emerald-600 rounded-lg shrink-0 hover:bg-emerald-500"
          >
            Search
          </button>
        </motion.form>
      </div>
    </section>
  );
}


